import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';

const Terms = () => {
    return (
        <>
            <SEO
                title="Naudojimosi taisyklės ir sąlygos – SmartPanda"
                description="SmartPanda naudojimosi taisyklės ir sąlygos. Informacija apie platformos naudojimą, paskyras, prenumeratas, mokėjimus ir vartotojų atsakomybę."
                canonical="/taisykles"
            />

            <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-4xl mx-auto">

                    {/* Header */}
                    <div className="text-center mb-12">

                        <Link
                            to="/"
                            className="inline-block mb-4 text-purple-600 font-bold hover:underline"
                        >
                            ← Grįžti į pradžią
                        </Link>

                        <h1 className="text-4xl font-bold text-gray-900">
                            Naudojimosi taisyklės ir sąlygos
                        </h1>

                        <p className="text-gray-500 mt-2 italic">
                            Paskutinį kartą atnaujinta: 2026 m. balandžio 21 d.
                        </p>
                    </div>

                    <div className="bg-white rounded-3xl shadow-xl p-10 prose prose-purple max-w-none text-gray-700">

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
                                1. Paslaugų aprašymas
                            </h2>

                            <p>
                                „SmartPanda“ yra edukacinė platforma,
                                skirta vaikų mokymuisi, naudojant dirbtinį
                                intelektą (AI). Mes teikiame interaktyvius
                                žaidimus, personalizuotas užduotis ir
                                pažangos stebėjimo įrankius.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
                                2. Paskyrų registracija
                            </h2>

                            <p>
                                Vartotojai privalo pateikti teisingą
                                informaciją registracijos metu. Tėvai yra
                                atsakingi už vaikų paskyrų valdymą ir jų
                                veiklą platformoje.
                            </p>

                            <ul className="list-disc pl-6 space-y-2 mt-4">
                                <li>
                                    Draudžiama dalintis viena paskyra su
                                    trečiaisiais asmenimis.
                                </li>

                                <li>
                                    Vartotojas atsako už savo slaptažodžio
                                    saugumą.
                                </li>

                                <li>
                                    Registracija patvirtina sutikimą su
                                    šiomis taisyklėmis.
                                </li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
                                3. Prenumeratos ir mokėjimai
                            </h2>

                            <p>
                                Mes siūlome kelis prenumeratos lygius
                                (NEMOKAMAS, BASIC, PREMIUM, FAMILY).
                                Mokėjimai apdorojami per saugų „Stripe“
                                mokėjimo tarpininką.
                            </p>

                            <ul className="list-disc pl-6 space-y-2 mt-4">
                                <li>
                                    Prenumerata atnaujinama automatiškai
                                    kiekvieną mėnesį.
                                </li>

                                <li>
                                    Atšaukimas įsigalioja pasibaigus
                                    einamajam atsiskaitymo laikotarpiui.
                                </li>

                                <li>
                                    Grąžinimai vykdomi tik įstatymų
                                    numatytais atvejais.
                                </li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
                                4. Intelektinė nuosavybė
                            </h2>

                            <p>
                                Visas turinys esantis platformoje,
                                įskaitant programinį kodą, dizainą, tekstus
                                ir AI sugeneruotus modelius, priklauso
                                „SmartPanda“ arba jos licencijų davėjams.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
                                5. Atsakomybės ribojimas
                            </h2>

                            <p>
                                Platforma teikiama „tokia, kokia yra“.
                                Nors siekiame maksimalaus tikslumo, mes
                                neatsakome už laikinus trikdžius ar AI
                                sugeneruoto turinio netikslumus.
                            </p>
                        </section>

                    </div>

                    <div className="mt-12 text-center text-gray-500 text-sm">
                        <p>
                            © 2026 SmartPanda. Visos teisės saugomos.
                        </p>
                    </div>

                </div>
            </div>
        </>
    );
};

export default Terms;
